export default {
  strict: true,
  namespaced: true,
  state: {
    stack: [],
    options: {},
    isShowLoding: false,
    windowRect: {
      height: 0,
      width: 0,
    },
    noOperationTimer: null,
    noOperationTimerInterval: 180000,
    goToRedirectHomeOption: {
      interval: 10 * 60 * 1000,
      callback: () => location.href = './home.html',
    },
  },
  mutations: {
    push(state, page) {
      state.stack.push(page);
    },
    pop(state) {
      if (state.stack.length > 1) {
        state.stack.pop();
      }
    },
    replace(state, page) {
      state.stack.pop();
      state.stack.push(page);
    },
    reset(state, page) {
      state.stack = [page || state.stack[0]];
    },
    options(state, newOptions = {}) {
      state.options = newOptions;
    },
    showLoading(state) {
      state.isShowLoding = true;
    },
    hideLoading(state) {
      state.isShowLoding = false;
    },
    getWindowRect(state) {
      state.windowRect.height = window.innerHeight;
      state.windowRect.width = window.innerWidth;
    },
  },
  actions: {
    startNoOperationTimer({ state, commit, dispatch }, { interval = 180000, callback = null } = {}) {
      if (state.noOperationTimer) return;

      dispatch('setNoOperationTimerInterval', interval);

      state.noOperationTimer = setInterval( () => {
        if (callback) {
          callback();
        } else {
          commit('reset');
        };
      }, state.noOperationTimerInterval)
    },
    updateNoOperationTimer({ dispatch }, { interval = 180000, callback = null } = {}) {
      dispatch('clearNoOperationTimer');
      dispatch('startNoOperationTimer', { interval, callback });
    },
    clearNoOperationTimer({ state }) {
      clearInterval(state.noOperationTimer);
      state.noOperationTimer = null;
    },
    setNoOperationTimerInterval({ state }, interval) {
      state.noOperationTimerInterval = interval;
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/modules/navigator/app_navigator.js